/**
 * Initializes the generic TextInput
 *
 */
export function initZdsTextInput() {
  // Handle ClearInput function
  $('.clear_input').on('mousedown', (e) => {
    $(e.target).siblings('.input_field').val('');
  });

  $('.input_field').on('focus keyup', (e) => {
    $(e.target).next('.clear_input').show();
  });

  $('.input_field').on('blur', (e) => {
    $(e.target).next('.clear_input').hide();
  });
}
